<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMove_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m5.638 2-2.897.024a.72.72 0 0 0-.717.717L2 5.638a.705.705 0 0 0 .71.71.72.72 0 0 0 .718-.717l.011-1.217 2.872 2.872a.724.724 0 0 0 1.024-.005.724.724 0 0 0 .004-1.023l-2.82-2.82 1.112-.01a.72.72 0 0 0 .717-.718.705.705 0 0 0-.71-.71m0 12-2.897-.024a.72.72 0 0 1-.717-.717L2 10.362a.705.705 0 0 1 .71-.71.72.72 0 0 1 .718.717l.011 1.217 2.872-2.872a.724.724 0 0 1 1.024.004.724.724 0 0 1 .004 1.024l-2.82 2.82 1.112.01a.72.72 0 0 1 .717.717.705.705 0 0 1-.71.71m7.62-11.976L10.363 2a.705.705 0 0 0-.71.71.72.72 0 0 0 .717.718l1.112.01-2.82 2.82a.724.724 0 0 0 .004 1.023.724.724 0 0 0 1.024.005l2.872-2.872.011 1.217a.72.72 0 0 0 .717.717.705.705 0 0 0 .71-.71l-.023-2.897a.72.72 0 0 0-.717-.717M10.363 14l2.897-.024a.72.72 0 0 0 .717-.717L14 10.362a.705.705 0 0 0-.71-.71.72.72 0 0 0-.718.717l-.011 1.217-2.872-2.872a.724.724 0 0 0-1.024.004.724.724 0 0 0-.004 1.024l2.82 2.82-1.112.01a.72.72 0 0 0-.717.717.705.705 0 0 0 .71.71"
        clip-rule="evenodd"
    />
</svg>
